import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Spinner,
} from 'reactstrap';
import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { createUseStyles } from 'react-jss';
import axios from 'utils/axios';
import { useHistory, Link } from 'react-router-dom';
import { isEmpty } from 'lodash';

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '500px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
  verifyButton: {
    backgroundColor: '#2675b8',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    width: '100%',
  },
});

export default function VerifyOTPModal({
  toggleForgotPasswordModalOpen,
  forgotPasswordModalOpen,
  username,
  resendPassword,
  resendCounter,
  isSendingOTP,
}) {
  const history = useHistory();
  const classes = useStyles();
  const [otp, setOtp] = useState(null);
  const [verifyingOTP, setVerifyingOTP] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [timer, setTimer] = useState(60);
  // const [isSendingOTP, setSendingOTP] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    startTimer();
  }, [resendCounter]);

  const startTimer = () => {
    let initialTimer = 60;
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimer(initialTimer - 1);
      initialTimer -= 1;
      if (initialTimer <= 0) {
        clearInterval(timerRef.current);
        // toggleVerifyOTPModalOpen(false);
      }
    }, 1000);
  };

  async function verifyOtp() {
    try {
      if (!otp || isEmpty(newPassword)) {
        return toast.dark('Please provide all the fields.', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setVerifyingOTP(true);
      await axios.post('/users/confirmForgotPassword', {
        username,
        code: otp,
        password: newPassword,
      });

      setOtp(null);
      toast.dark('Password successfully changed', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      toggleForgotPasswordModalOpen();
      history.push('/auth/login');
    } catch (error) {
      if (error.response?.data?.message) {
        toast.dark(error.response.data.message, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.dark(error.message, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    setVerifyingOTP(false);
  }

  const sendOTPtoPhone = () => {
    const user = username?.substring(1, username?.length);
    resendPassword({ username: user });
  };

  return (
    <Modal
      isOpen={forgotPasswordModalOpen}
      toggle={toggleForgotPasswordModalOpen}
      className={classes.modal}
      backdrop={'static'}
      fade={true}
    >
      <ModalHeader
        toggle={toggleForgotPasswordModalOpen}
        style={{ marginTop: '10px' }}
        closeButton={true}
        className={classes.modalHeader}
      >
        Enter a New Password
      </ModalHeader>
      <ModalBody style={{ marginTop: '-30px' }}>
        <div className="form-group">
          <div className="row">
            <div className="col-12 ">
              {`We've sent a Password Reset OTP to this phone number.Please enter the OTP and the New Password.`}
            </div>
            <div className="col-12 mt-3">
              <FormGroup>
                <label className="form-control-label" htmlFor="input-city">
                  OTP
                </label>
                <Input
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  type="number"
                />
              </FormGroup>

              <FormGroup>
                <label className="form-control-label" htmlFor="input-city">
                  New Password
                </label>
                <InputGroup
                  className="input-group-alternative"
                  style={{
                    boxShadow: 'none',
                    border: '0.5px solid #cfcfcf',
                    borderRadius: '3px',
                  }}
                >
                  <Input
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    type={showConfirmPassword ? 'text' : 'password'}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i
                        className={`fa ${
                          showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'
                        }`}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        style={{ cursor: 'pointer' }}
                      />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </div>

            <div class="col-10">
              {true && (
                <>
                  <small>Didn't received the code?</small>
                  &nbsp;&nbsp;
                  <Link
                    className={classes.loginWithOTP}
                    onClick={() => {
                      sendOTPtoPhone(username);
                      // setFieldValue('otp', '');
                    }}
                  >
                    <small>Resend OTP {isSendingOTP}</small>
                  </Link>
                  {isSendingOTP && (
                    <Spinner
                      style={{
                        color: '#2675b8',
                        fontSize: 5,
                        marginLeft: 10,
                        marginTop: 5,
                      }}
                      size="sm"
                    />
                  )}
                </>
              )}
            </div>
            <div class="col-2 ">
              {timer > 0 && `00:${timer < 10 ? '0' : ''}${timer}`}
            </div>

            <div className="col-12">
              <Button
                color="primary"
                className={classes.verifyButton}
                onClick={verifyOtp}
                disabled={timer <= 0}
              >
                {verifyingOTP ? 'Processing...' : 'Update Password'}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
